exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".e8Jk50KYHgyMcn7BR59IC{border-radius:4px;background-color:#fff;float:left;width:100%}.TkzIKfoZueM-dQWSljJLG{color:#fff!important;background-color:#666}.TkzIKfoZueM-dQWSljJLG div{color:#fff!important}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/organisms/Timeline/Containers/style.css"],"names":[],"mappings":"AAAA,uBACI,kBAAmB,AACnB,sBAAuB,AACvB,WAAY,AACZ,UAAY,CACf,AAED,uBACI,qBAAuB,AACvB,qBAAuB,CAC1B,AAED,2BACI,oBAAuB,CAC1B","file":"style.css","sourcesContent":[".box {\n    border-radius: 4px;\n    background-color: #fff;\n    float: left;\n    width: 100%;\n}\n\n.needApprove {\n    color: #fff !important;\n    background-color: #666;\n}\n\n.needApprove div {\n    color: #fff !important;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"box": "e8Jk50KYHgyMcn7BR59IC",
	"needApprove": "TkzIKfoZueM-dQWSljJLG"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/organisms/Timeline/Containers/style.css
// module id = 855
// module chunks = 0 1 2 3 4 6